/*
 * Copyright (C) 2024 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {DividerBlock} from './DividerBlock'

const DividerBlockIcon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 9.38461H15.8462V8H2V9.38461Z" fill="currentColor"/>
<path d="M9.53033 0.46967C9.23744 0.176777 8.76256 0.176777 8.46967 0.46967L3.6967 5.24264C3.40381 5.53553 3.40381 6.01041 3.6967 6.3033C3.98959 6.59619 4.46447 6.59619 4.75736 6.3033L9 2.06066L13.2426 6.3033C13.5355 6.59619 14.0104 6.59619 14.3033 6.3033C14.5962 6.01041 14.5962 5.53553 14.3033 5.24264L9.53033 0.46967ZM9.75 2L9.75 1L8.25 1L8.25 2L9.75 2Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.3033 12.7574L9.53034 17.5303C9.23745 17.8232 8.76257 17.8232 8.46968 17.5303L3.69671 12.7574C3.40381 12.4645 3.40381 11.9896 3.69671 11.6967C3.9896 11.4038 4.46447 11.4038 4.75737 11.6967L9.00001 15.9393L13.2426 11.6967C13.5355 11.4038 14.0104 11.4038 14.3033 11.6967C14.5962 11.9896 14.5962 12.4645 14.3033 12.7574Z" fill="currentColor"/>
</svg>
`

export {DividerBlock, DividerBlockIcon}
